export default __webpack_public_path__ + "static/imperfective-habitual-past-6426ad6e7cb2fb58a35162447261b2c1.svg";